export const usersTableColumns = [
  {
    title: 'Имя (логин)',
    dataIndex: 'nick_name',
    sorter: true,
  },
  {
    title: 'CRM',
    dataIndex: 'crmname',
    sorter: true,
  },
  {
    title: 'Звонков',
    dataIndex: 'daycalls',
    sorter: true,
    width: '15%',
  },
]
